module.exports = __webpack_public_path__ + "static/media/mocu.9184888f.png";